export const CONTINENTS = ["Europa", "Asia", "Africa", "Nord America", "Sud America", "Oceania"];
export const SEASONS = ["Primavera", "Estate", "Autunno", "Inverno", "Tutto l'anno"];
export const DIFFICULTIES = ["facile", "medio", "impegnativo"];
export const TRAVEL_TYPES = ["city break", "on the road", "trekking", "mare", "natura", "avventura", "relax"];
export const BUDGET_LEVELS = [
  { value: "basso", label: "Budget basso" },
  { value: "medio", label: "Budget medio" },
  { value: "alto", label: "Budget alto" },
];

export const CONTENT_TYPES_META = {
  articles: { label: "Articoli Blog", singular: "Articolo", route: "/blog", icon: "FileText" },
  itineraries: { label: "Itinerari testati", singular: "Itinerario", route: "/itinerari-testati", icon: "Map" },
  budgets: { label: "Budget e simulazioni", singular: "Budget", route: "/budget", icon: "Wallet" },
  resources: { label: "Tips, Tool e Risorse", singular: "Risorsa", route: "/risorse", icon: "Wrench" },
  guides: { label: "Guide PDF", singular: "Guida", route: "/guide", icon: "BookOpen" },
  pages: { label: "Pagine", singular: "Pagina", route: "/pagina", icon: "File" },
};
